import actions from './actions';

const initState = {
    schedules: [],
    isFetchingSchedules: false,
    isPostingChange: false,
    isFetchingChanges: false,
    fromScheduleDetailsPage: false,
    changes: [],
    currentTablePage: "",
    currentDateRange: "",
    currentStartDate: "",
    currentEndDate: "",
    pouchBarcode: undefined,
    isDeletingSchedule: false,
    deletionCompleted: false,
};

export default function (state = initState, action) {
    switch (action.type) {
        case actions.POST_SCHEDULE_CHANGE:
            return {
                ...state,
                isPostingChange: true,
                isFetchingSchedules: true,
            };
        case actions.POST_SCHEDULE_CHANGE_SUCCESS:
            return {
                ...state,
                isPostingChange: false,
                isFetchingSchedules: false,
            };
        case actions.POST_SCHEDULE_CHANGE_ERROR:
            return {
                ...state,
                isPostingChange: false,
                isFetchingSchedules: false,
            };
        case actions.FETCH_SCHEDULE_DETAILS: 
            return {
                ...state,
                isFetchingSchedules: true
            };
        case actions.FETCH_SCHEDULE_DETAILS_SUCCESS: 
            return {
                ...state,
                isFetchingSchedules: false,
                schedule: action.schedule
            };
        case actions.FETCH_SCHEDULE_DETAILS_ERROR:
            return {
                ...state,
                isFetchingSchedules: false,
                schedule: []
            };
        case actions.FETCH_KARIE_USER_SCHEDULES:
            return {
                ...state,
                isFetchingSchedules: true,
            };
        case actions.FETCH_KARIE_USER_SCHEDULES_SUCCESS:
            return {
                ...state,
                isFetchingSchedules: false,
                schedules: action.schedules,
            };
        case actions.FETCH_KARIE_USER_SCHEDULES_ERROR:
            return {
                ...state,
                isFetchingSchedules: false,
                schedules: [],
            };
        case actions.FETCH_SCHEDULE_CHANGES:
            return {
                ...state,
                isFetchingChanges: true,
            };
        case actions.FETCH_SCHEDULE_CHANGES_SUCCESS:
            return {
                ...state,
                isFetchingChanges: false,
                changes: action.changes,
            };
        case actions.FETCH_SCHEDULE_CHANGES_ERROR:
            return {
                ...state,
                isFetchingChanges: false,
                changes: [],
            };
        case actions.FETCH_PHARMACY_SCHEDULES:
            return {
                ...state,
                isFetchingSchedules: true,
                pouchBarcode: action.pouchBarcode,
            };
        case actions.FETCH_PHARMACY_SCHEDULES_SUCCESS:
            return {
                ...state,
                isFetchingSchedules: false,
                schedules: action.schedules,
            };
        case actions.FETCH_PHARMACY_SCHEDULES_ERROR:
            return {
                ...state,
                isFetchingSchedules: false,
                schedules: [],
            };
        case actions.GET_CURRENT_TABLE_PAGE: 
            return {
                ...state,
                currentTablePage: action.page,
            };
        case actions.GET_CURRENT_DATE_RANGE:
            return {
                ...state,
                currentDateRange: action.dateString,
                currentStartDate: action.startDate,
                currentEndDate: action.endDate,
            };
        case actions.FROM_SCHEDULE_DETAILS_PAGE: 
            return {
                ...state,
                fromScheduleDetailsPage: action.check,
                currentTablePage: action.page,
                currentDateRange: action.dateString,
                pouchBarcode: action.pouchBarcode
            }
        case actions.DELETE_SCHEDULE: 
            return { ...state, isDeletingSchedule: true, deletionCompleted: false }
        case actions.DELETE_SCHEDULE_SUCCESS: 
            return { ...state, isDeletingSchedule: false, deletionCompleted: true }
        case actions.DELETE_SCHEDULE_ERROR: 
            return { ...state, isDeletingSchedule: false, deletionCompleted: false }
        default:
            return state;
    }
}
